import React, { useState, useEffect, useRef } from 'react'
import {Dropdown, SelectableOptionMenuItemType} from '@fluentui/react';
import Api from '../../../services/Api'
import axios from 'axios';

const CancelToken = axios.CancelToken;

const DropdownFilter = ({ fieldName, urlFetch, title, optionFieldName, onChange, noselection, group, defaultEmpty, includeSelectAll, values = [], multiSelect = true, includeEmpty, defaultValues = []}) => {

    const [options, setOptions] = useState([]);
    const [possibilities, setPossibilities] = useState([]);
    const [selection, setSelection] = useState(defaultValues);
    const cancelSource = useRef(null);

    useEffect(() => {
        cancelSource.current = CancelToken.source();

        const getPossibilities = () => {
            Api.get(urlFetch, {
                cancelToken: cancelSource.current.token
            })
            .then(res => res.data)
            .then(posts => {
                    fitPossibilities([...posts, ...values]);
                }
            )
            .catch((err) => {});
        }

        if (urlFetch) {
            getPossibilities();
        }
        else {
            fitPossibilities(values);
        }

        return () => {
            cancelSource.current.cancel();
        }
    }, []);
    
    // shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
    //     if(this.state.selection.length !== nextState.selection.length)
    //     {
    //         return true;
    //     }
    //     return false;
    // }


    const fitPossibilities = (posts) => {
        const optionField = optionFieldName || 'value';
        
        const options = group
            ? posts.reduce((a, b, index) => {
                var grouped = a.filter(x => x.text === b[optionField]);
                if (grouped.length > 0) {
                    grouped[0].key += `,${b.id}`;
                }
                else {
                    a.push({
                        key: b.id,
                        text: b[optionField],
                        itemType: SelectableOptionMenuItemType.Normal,
                        index: index + 10
                    });
                }
                return a;
            }, [])
            : posts.map((r, index) => {
                return {
                    key: r.id || r.key,
                    text: r[optionField] ? r[optionField] : r.value,
                    itemType: SelectableOptionMenuItemType.Normal,
                    index: index + 10
                }
            });

        if (includeSelectAll) {
            options.push({
                key: 'all',
                text: multiSelect ? 'Select all' : 'Select',
                itemType: SelectableOptionMenuItemType.Normal,
                index: 0
            });
            options.push({
                key: 'divider_1',
                text: '-',
                itemType: SelectableOptionMenuItemType.Divider,
                index: 1
            });
        }

        if (includeEmpty) {
            options.push({
                key: -1,
                text: 'Empty',
                itemType: SelectableOptionMenuItemType.Normal
            })
        }

        setSelection(
            defaultValues && defaultValues.length > 0 
            ? defaultValues 
            : !defaultEmpty 
                ? options.filter(x => x.itemType === SelectableOptionMenuItemType.Normal).sort((a, b) => a.index - b.index).map(o => o.key) 
                : []
        );
        setPossibilities(options.filter(x => x.itemType === SelectableOptionMenuItemType.Normal));
        setOptions(options.sort((a, b) => a.index - b.index));
    }

    const onSelectionChange = (e, item) => {
        //const choice = item.key;
        // let sel = selection.map(x => x);
        // if(sel.filter(x => x === choice).length > 0)
        // {
        //     let newArray =  sel.filter(x => x !== choice )
        //     sel = newArray;
        // }
        // else
        // {
        //     sel.push(choice);
        // }
        
        let sel;
        if (multiSelect === false) {
            sel = item.key;
        } else {
            if (item.key === 'all') {
                sel = item.selected ? [...possibilities.map(x => x.key)] : [];
            }
            else {
                sel = item.selected ? [...selection, item.key] : selection.filter(key => key !== item.key && key !== 'all');
                if (includeSelectAll && sel.length === possibilities.length - 1) {
                    sel = [...sel, 'all'];
                }
            }
        }
    
        setSelection(sel);

        if (sel.length === 0 && noselection) {
            noselection();
            return;
        }    

        if (multiSelect) {
            onChange(fieldName, sel.length === possibilities.length && !defaultEmpty ? null : sel.filter(key => key !== 'all').join(','));
        } else {
            onChange(fieldName, sel);
        }
    }

    const onRenderTitle = (items) => {
        return items.length === possibilities.length
            ? 'All' 
            : items.sort((a, b) => a.index - b.index).map(x => x.text).join(', ');
    }

    return(
        <div>
            {multiSelect ? 
                <Dropdown
                    label = {title}
                    placeholder="Select"
                    options={options}
                    onChange={onSelectionChange}
                    onRenderTitle={onRenderTitle}
                    selectedKeys={selection}
                    multiSelect
                />
                :
                <Dropdown
                    label = {title}
                    placeholder="Select"
                    options={options}
                    onChange={onSelectionChange}
                    onRenderTitle={onRenderTitle}
                />
            }
        </div>
    );
}
export default DropdownFilter



// WEBPACK FOOTER //
// ./src/components/Administration/Filters/DropdownFilter.js